import { SIZE_50 } from '@/lib/gridElements/size';
import { videoViewsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/tiktok/videoViewsAvgTimeWatched';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViewsAvgTimeWatchedConfig = {
    ...videoViewsAvgTimeWatchedConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
